import React from 'react';

import GeneralCustomAlert from './Alert';
import BusinessNetwork from './BusinessNetwork';
import EntityRecord from './EntityRecord';
import PurchaseOrderModals from './PurchaseOrderModals';
import TenderModal from './TenderModal';

const GeneralComponents = () => {
  return (
    <>
      <GeneralCustomAlert />
      <BusinessNetwork />
      <TenderModal />
      <PurchaseOrderModals />
      <EntityRecord />
    </>
  );
};

export default GeneralComponents;
